import './App.css';
import './fonts.css';
import { Offer } from './Components/Offer/Offer';
import { NotFound } from './Pages/NotFound';
import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { PrivacyPolicy } from './Pages/PrivacyPolicy';
import { TnC } from './Pages/TnC';
import { useApi } from './Hooks/useApi';
import { ApiContext } from './Contexts/ApiContext';
import { VerifyWithCrdx } from './Components/Checkout/VerifyWithCrdx';
import { AuthorizeWithCrdx } from './Components/Checkout/AuthorizeWithCrdx';
import { UnderConstruction } from './Pages/UnderConstruction';
import { ViewCredit } from './Pages/ViewCredit';
import { CenteredLoader } from './Pages/CenteredLoader';

function App() {
  const apiContext = useApi();
  const [isCollapsed, setIsCollapsed] = useState(false); //state mgmt for offer pg
  const listenToHostEvent = () => {
    window.addEventListener('message', (e) => {
      const msgFromHost = e.data.message;
      if (msgFromHost) {
        // console.log('msg received on REACT APP:', msgFromHost);
        msgFromHost === 'collapse_iframe_content' ? setIsCollapsed(true) : setIsCollapsed(false);
      } else return;
    });
  };
  listenToHostEvent();
  return (
    <div className='App'>
      <header className='App-header'>
        <ApiContext.Provider value={apiContext}>
          <Routes>
            <Route key='not-found' path='*' exact element={<NotFound />} />
            <Route key='under-construction' path='/under-construction' exact element={<UnderConstruction />} />
            <Route key='offer' path='/offer' exact element={<Offer isCollapsed={isCollapsed} />} />
            <Route key='privacy-policy' path='/privacy-policy' exact element={<PrivacyPolicy />} />
            <Route key='terms-conditions' path='/terms-conditions' exact element={<TnC />} />
            <Route
              key='verify' //this one uses crdrx
              path='/verify'
              exact
              element={<VerifyWithCrdx />}
            />
            <Route
              key='authorize' //this one uses crdrx
              path='/authorize'
              exact
              element={<AuthorizeWithCrdx />}
            />
            <Route key='credit' path='/credit' exact element={<ViewCredit />} />
            <Route key='centered-loader' path='/centered-loader' exact element={<CenteredLoader />} />
          </Routes>
        </ApiContext.Provider>
      </header>
    </div>
  );
}
export default App;
